import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { useGameContext } from "../../../game/GameContext/GameContext";
import { convertToK } from "../../../helpers/utils";
import Button from "../../../ui/Button/Button";
import { getFloat } from "../../../helpers/formatNumber";
import { BetPickerWrapper } from "./BetAmount.styled";
var BetPicker = function () {
    var _a = useGameContext(), setBetAmount = _a.setBetAmount, inProgress = _a.inProgress, balance = _a.balance, autoPlayInProgress = _a.autoPlayInProgress, controlPanelDisabled = _a.controlPanelDisabled;
    var pickerButtonDisabled = useCallback(function (value) {
        if (inProgress || autoPlayInProgress || controlPanelDisabled)
            return true;
        if (parseFloat(getFloat(balance / 10000)) < value)
            return true;
        return false;
    }, [balance, inProgress, autoPlayInProgress, controlPanelDisabled]);
    var buttonValues = [1, 10, 100, 1000];
    return (_jsx(BetPickerWrapper, { children: buttonValues.map(function (value) {
            return (_jsx(Button, { fullWidth: true, variant: "inputButtonLarge", disabled: pickerButtonDisabled(value), onClick: function () { return setBetAmount(value); }, children: convertToK(value) }, value));
        }) }));
};
export default BetPicker;
//# sourceMappingURL=Betamount.picker.js.map